export const VISITED_REISETERMIN = 'userSettingsLocal.vistedReisetermin';
export const SET_LAST_VISITED_REISETERMIN_ID = 'userSettingsLocal.setLastVisitedReiseterminId';
export const SET_LAST_VISITED_REISETERMIN_KUERZEL = 'userSettingsLocal.setLastVisitedReiseterminKuerzel';

export const SET_IS_USING_CUSTOM_ROLES = 'userSettingsLocal.setIsUsingCustomRoles';

const state = {
  lastVisitedReiseterminId: null,
  lastVisitedReiseterminKuerzel: null,
  alwaysHideReiseterminCompactHeader: false,
  hideRoleIndicators: false,
  isAnimationEnabled: false,
  isUsingCustomRoles: false,
  customRoles: [],
};
const actions = {
  [VISITED_REISETERMIN](context, { id, kuerzel }) {
    context.commit(SET_LAST_VISITED_REISETERMIN_ID, id);
    context.commit(SET_LAST_VISITED_REISETERMIN_KUERZEL, kuerzel);
  },
};
const mutations = {
  [SET_LAST_VISITED_REISETERMIN_ID](state, id) {
    state.lastVisitedReiseterminId = id;
  },
  [SET_LAST_VISITED_REISETERMIN_KUERZEL](state, kuerzel) {
    state.lastVisitedReiseterminKuerzel = kuerzel;
  },
  [SET_IS_USING_CUSTOM_ROLES](state, isUsingCustomRoles) {
    state.isUsingCustomRoles = isUsingCustomRoles;
  },
};
const getters = {
  // Ältere Einträge im lokalen Speicher enthalten Objekte, neue nur noch die Schlüssel
  customRoles(state) {
    return Array.isArray(state.customRoles) && state.customRoles.length > 0
      ? state.customRoles.map(role => role?.key ?? role)
      : null;
  },
  lastVisitedReiseterminId(state) {
    return state.lastVisitedReiseterminId;
  },
  lastVisitedReiseterminKuerzel(state) {
    return state.lastVisitedReiseterminKuerzel;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
